/**
 * 小红书爆款 - 情感故事模板 Compositions
 *
 * 包含：励志故事、成长经历、情感共鸣等情感化模板
 */

import { Composition } from 'remotion';
import { XHSEmotionalStory } from './XHSEmotionalStory';

const inspirationalStoryExample = {
  question: '你经历过低谷吗？',
  questionSubtext: '这些真实故事，或许能给你力量',
  stories: [
    {
      number: '1',
      title: '失业负债，我重新站了起来',
      content: '30岁失业、负债10万。我没有放弃，每天学新技能，3个月后拿到更好的 offer。',
      emoji: '💪',
    },
    {
      number: '2',
      title: '零基础逆袭年薪40万',
      content: '从完全不懂编程开始，每天坚持8小时。半年后，我收到了梦寐以求的 offer。',
      emoji: '✨',
    },
    {
      number: '3',
      title: '副业收入超过主业 2 倍',
      content: '利用下班时间做自媒体，3个月粉丝破万。现在副业收入已是主业的两倍。',
      emoji: '💰',
    },
  ],
  encouragement: '你也可以！',
  ctaText: '关注我，一起成长',
  sceneTitle: '💪 3 个逆袭故事',
};

const growthExperienceExample = {
  question: '什么时候开始改变？',
  questionSubtext: '最好的时间就是现在',
  stories: [
    {
      number: '1',
      title: '每天早起 1 小时的复利',
      content: '利用早晨学习，一年掌握 3 项新技能、收入翻了一倍。早起改变了我的人生。',
      emoji: '🌅',
    },
    {
      number: '2',
      title: '坚持运动 100 天的蜕变',
      content: '从零基础到跑完 10 公里，身体更好了，精力也更充沛了。',
      emoji: '🏃',
    },
    {
      number: '3',
      title: '一年读 50 本书的升级',
      content: '每天 30 分钟阅读，一年下来思维方式彻底改变。读书是最便宜的投资。',
      emoji: '📚',
    },
  ],
  encouragement: '行动改变命运',
  ctaText: '点赞关注，一起进步',
  sceneTitle: '🌱 3 个成长习惯',
};

const emotionalResonanceExample = {
  question: '你有没有想过放弃？',
  questionSubtext: '请记住，黎明前最黑暗',
  stories: [
    {
      number: '1',
      title: '考研失败 3 次，第 4 次上岸',
      content: '每次都差一点点，但我没有放弃。第 4 次，我终于考上了梦想中的学校。',
      emoji: '🎓',
    },
    {
      number: '2',
      title: '创业失败 2 次，第 3 次成功',
      content: '赔光了所有积蓄，但总结了经验教训。第 3 次创业终于拿到了投资。',
      emoji: '💼',
    },
    {
      number: '3',
      title: '住院 3 个月后，我学会了珍惜',
      content: '躺在病床上，我才明白健康最重要。出院后，我每天都认真对待生活。',
      emoji: '❤️',
    },
  ],
  encouragement: '不要放弃自己',
  ctaText: '点赞收藏，永不放弃',
  sceneTitle: '❤️ 3 段坚持的力量',
};

export const XHSEmotionalStoryCompositions = () => {
  return (
    <>
      <Composition
        id="XHS-Viral-InspirationalStory"
        component={XHSEmotionalStory}
        durationInFrames={600}
        fps={30}
        width={1080}
        height={1920}
        defaultProps={inspirationalStoryExample}
      />

      <Composition
        id="XHS-Viral-GrowthExperience"
        component={XHSEmotionalStory}
        durationInFrames={600}
        fps={30}
        width={1080}
        height={1920}
        defaultProps={growthExperienceExample}
      />

      <Composition
        id="XHS-Viral-EmotionalResonance"
        component={XHSEmotionalStory}
        durationInFrames={600}
        fps={30}
        width={1080}
        height={1920}
        defaultProps={emotionalResonanceExample}
      />
    </>
  );
};
